import { render } from "./LabelTag.vue?vue&type=template&id=4bd4852a"
import script from "./LabelTag.vue?vue&type=script&lang=js"
export * from "./LabelTag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__